import { render } from "./ourClients.vue?vue&type=template&id=6a8791f8&ts=true"
import script from "./ourClients.vue?vue&type=script&lang=ts"
export * from "./ourClients.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__